import { useWizard } from 'use-wizard';
import { WizardSteps } from '@features/Unsubscribe/steps/WizardSteps';
import type { TpWizardValues } from '@features/Unsubscribe/types';
import { MANAGE_SUBSCRIPTION_PATHS } from '@features/Unsubscribe/сonstants';
export const Manage = () => {
  const [step, wizard] = useWizard(MANAGE_SUBSCRIPTION_PATHS);
  return <WizardSteps {...{
    wizard,
    step: step as TpWizardValues
  }} data-sentry-element="WizardSteps" data-sentry-component="Manage" data-sentry-source-file="index.tsx" />;
};